import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a1f6265"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "document bg-white relative overflow-y-scroll" }
const _hoisted_2 = {
  key: 0,
  class: "body"
}
const _hoisted_3 = { class: "title-section-spacing" }
const _hoisted_4 = {
  key: 0,
  class: "font-bold block text-left"
}
const _hoisted_5 = { class: "block date" }
const _hoisted_6 = { class: "options w-full text-right fixed relative" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-section-spacing" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "font-bold block text-left" }, "Documento")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SecondaryButton = _resolveComponent("SecondaryButton")!
  const _component_DocumentCard = _resolveComponent("DocumentCard")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_DeleteDocumentDialog = _resolveComponent("DeleteDocumentDialog")!
  const _component_AddEditDocumentModalDialog = _resolveComponent("AddEditDocumentModalDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.doc)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_SecondaryButton, {
                class: "edit-document text-primary block float-right text-primary block text-black-600 bg-primary-50",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShowingEditDialog = true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Modifica documento")
                ]),
                _: 1
              }),
              (_ctx.doc.title)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(_ctx.doc.title), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, "Data inserimento: " + _toDisplayString(_ctx.moment.unix(_ctx.doc.createdTs).format('DD/MM/YYYY')), 1),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_SecondaryButton, {
                  class: "delete text-primary block float-right text-primary block text-red-600 bg-red-100",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowingDeleteDialog = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Elimina")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_7,
              _createVNode(_component_DocumentCard, {
                class: "preview",
                "model-value": _ctx.doc,
                "is-read-only": true,
                scope: _ctx.scope,
                "working-site-id": '',
                "user-id": '',
                "communication-id": '',
                tags: {}
              }, null, 8, ["model-value", "scope"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          message: "Salvataggio..."
        }))
      : _createCommentVNode("", true),
    (_ctx.isShowingDeleteDialog)
      ? (_openBlock(), _createBlock(_component_DeleteDocumentDialog, {
          key: 1,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowingDeleteDialog = false)),
          scope: _ctx.scope,
          "document-id": _ctx.doc.id,
          title: _ctx.doc.title
        }, null, 8, ["scope", "document-id", "title"]))
      : _createCommentVNode("", true),
    (_ctx.isShowingEditDialog)
      ? (_openBlock(), _createBlock(_component_AddEditDocumentModalDialog, {
          key: 2,
          modelValue: _ctx.doc,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.doc) = $event)),
          scope: _ctx.scope,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowingEditDialog = false))
        }, null, 8, ["modelValue", "scope"]))
      : _createCommentVNode("", true)
  ], 64))
}